import { render, staticRenderFns } from "./MStateBox.vue?vue&type=template&id=90719262&scoped=true"
import script from "./MStateBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MStateBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MStateBox.vue?vue&type=style&index=0&id=90719262&prod&lang=less"
import style1 from "./MStateBox.vue?vue&type=style&index=1&id=90719262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90719262",
  null
  
)

export default component.exports